import { RefreshCw } from "lucide-react";

import { LoadingState } from "@/components/loading-state";
import { Panel } from "@/components/panel";
import { QueryErrorState } from "@/components/query-error-state";
import { StatCard } from "@/components/stat-card";
import { useSignalsSummary } from "@/sdk/hooks/use-signals";

export function SignalsSummary() {
  const { data, isLoading, isError, refetch } = useSignalsSummary();

  if (isLoading) return <LoadingState text="Loading signals..." />;

  return (
    <Panel
      title="Signal Summary"
      actions={
        <button title="Refresh" onClick={() => refetch()} className="rounded p-1 text-xs text-white/40 hover:bg-white/10">
          <RefreshCw className="h-3 w-3" />
        </button>
      }
    >
      {isError ? (
        <QueryErrorState what="signal summary" onRetry={() => void refetch()} />
      ) : (
        <>
          <div className="mb-4 grid grid-cols-2 gap-2 md:gap-3 sm:grid-cols-4">
            <StatCard label="Total" value={String(data?.total_signals ?? 0)} />
            <StatCard label="Contrarian" value={String(data?.contrarian_count ?? 0)} />
            <StatCard label="Momentum" value={String(data?.momentum_count ?? 0)} />
            <StatCard label="Whale Flow" value={String(data?.whale_flow_count ?? 0)} />
          </div>
          <p className="text-xs text-white/45">Volume anomalies: {data?.volume_anomaly_count ?? 0}</p>
        </>
      )}
    </Panel>
  );
}
